export { default as NInputNumber, inputNumberProps } from './src/InputNumber';
